import { scope } from '@rehaje/core'
import { noop } from '@rehaje/shared'

import { JavaScriptNode } from '../JavaScript'

import type { JavaScriptSpecific } from '../JavaScript'
import type { ViewScope } from '@rehaje/core'

export interface TransformSpecific extends JavaScriptSpecific {}

@scope({
  type: 'Local',
  variables: [
    {
      get() {
        return this.getSelfViewScope()?.getLocalVariable('data')
      },
      name: 'data',
      type: 'Local'
    }
  ]
})
export default class TransformNode extends JavaScriptNode {
  override transpile(scope: ViewScope): (data?: any) => any {
    const transform = super.transpile(scope, true)
    if (typeof transform !== 'function') return noop
    return (data) => {
      scope.setLocalVariables({ data })
      return transform()
    }
  }
}
